export default __webpack_public_path__ + "static/media/satisfied.fd825376.svg";